module.exports = __webpack_public_path__ + "img/P1013573.4996da0b.jpg";